/**
 * Whether a tool result raised, decided or withdrew something that waits on a
 * person: a question (an ask) or an approval card. Home and Needs you refresh
 * at once instead of on their next poll, so they never trail the chat.
 */
const NEEDS_YOU_KEYS = ['approval_id', 'approval_request_id', 'ask_id', 'initiative_ask_id'];

const hasId = (value) => (typeof value === 'string' ? value.trim() !== '' : value != null && value !== false);

export const carriesNeedsYou = (result) => {
  if (!result || typeof result !== 'object' || Array.isArray(result)) return false;
  if (NEEDS_YOU_KEYS.some((key) => hasId(result[key]))) return true;
  const card = result.card;
  return Boolean(card && typeof card === 'object' && NEEDS_YOU_KEYS.some((key) => hasId(card[key])));
};
